import { Draft } from "immer";

import {
  WorkbenchTab,
  WorkbenchTabGroup,
  WorkbenchViewport,
  updateTabGroupsToMatchViewport,
} from "../../../components/workbench/state";

type PartialWorkbenchState<TTab extends WorkbenchTab> = {
  tabGroups: WorkbenchTabGroup<TTab>[];
  viewport: WorkbenchViewport;
};

export type UpdateWorkbenchViewportPayload = WorkbenchViewport;

/**
 * Synchronize the tab groups with the viewport, treating the viewport as
 * the source of truth. Makes the minimum possible changes to the tab groups.
 */
export function updateWorkbenchViewport<
  TState extends PartialWorkbenchState<TTab>,
  TTab extends WorkbenchTab,
>(state: Draft<TState>, payload: UpdateWorkbenchViewportPayload): void {
  state.viewport = payload;
  state.tabGroups = updateTabGroupsToMatchViewport(payload, state.tabGroups);
}
